module.exports = "https://img1.zhuanstatic.com/platform/zz-universal-pages/static/img/id_card_front_sample_new.70b76a70.png";